import { render, staticRenderFns } from "./Tipp_Card.vue?vue&type=template&id=fa707560"
import script from "./Tipp_Card.vue?vue&type=script&lang=js"
export * from "./Tipp_Card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports